import React from "react"

export default function Title(props) {
return <h1 style={{ fontSize :`30px`, color:`white`, fontFamily:`sans-serif`, marginBottom: `50px`}}>{props.pageTitle}</h1>
  }
  